import { TicketSelectPage } from '@/features/pages/ec/ticketSelect'
import type { NextPage } from 'next'

const Page: NextPage = () => {
  return <TicketSelectPage />
}

export default Page

export { getStaticPaths, getStaticProps } from '@/components/Functional/utils/getStaticFunctions'
